export default function InputLinkIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.55761 5.58063L11.1044 4.03383C11.4236 3.71439 11.8025 3.46095 12.2196 3.288C12.6368 3.11505 13.0839 3.02598 13.5354 3.02588C13.987 3.02577 14.4341 3.11464 14.8513 3.28739C15.2685 3.46014 15.6476 3.7134 15.9669 4.0327C16.2862 4.352 16.5395 4.73107 16.7122 5.14827C16.885 5.56548 16.9738 6.01263 16.9737 6.46418C16.9736 6.91573 16.8845 7.36284 16.7116 7.77996C16.5387 8.19708 16.2852 8.57604 15.9658 8.89519L13.7561 11.1049C13.4369 11.4241 13.0579 11.6773 12.6409 11.8501C12.2238 12.0228 11.7768 12.1117 11.3254 12.1117C10.874 12.1117 10.427 12.0228 10.0099 11.8501C9.59285 11.6773 9.2139 11.4241 8.8947 11.1049M10.4415 14.4195L8.8947 15.9663C8.57555 16.2857 8.19659 16.5391 7.77947 16.7121C7.36235 16.885 6.91524 16.9741 6.46369 16.9742C6.01214 16.9743 5.56499 16.8855 5.14779 16.7127C4.73058 16.5399 4.35151 16.2867 4.03221 15.9674C3.71291 15.6481 3.45966 15.269 3.2869 14.8518C3.11415 14.4346 3.02529 13.9875 3.02539 13.5359C3.0255 13.0844 3.11457 12.6372 3.28751 12.2201C3.46046 11.803 3.7139 11.424 4.03334 11.1049L6.24305 8.89519C6.56225 8.57599 6.9412 8.32279 7.35826 8.15003C7.77531 7.97728 8.22231 7.88837 8.67373 7.88837C9.12515 7.88837 9.57215 7.97728 9.98921 8.15003C10.4063 8.32279 10.7852 8.57599 11.1044 8.89519"
          stroke="#5E718D"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
